<template>
  <div class="Outer" ref="outer">
    <div class="Inner">
      <v-data-table
        height="55vh"
        fixed-header
        :v-model="selected"
        @input="enterSelect($event)"
        :headers="questDetailHeaders"
        :items="questDetailResults"
        item-key="questResultSysId"
        show-select
        class="elevation-1"
        @pagination="returnOri($refs.outer)"
      >
        <!-- <template v-slot:header.data-table-select="{ on , props }">
    <v-simple-checkbox
       color="purple"
       v-bind="props"
       v-on="on"
    />
</template> -->
        <template slot="item" slot-scope="props">
          <!-- 對於每一個 row 加上 tr 不然不會換行 -->

          <tr v-if="props.index < questDetailResults.length">
            <td>
              <v-simple-checkbox
                v-model="selectItem[props.index]"
                :ripple="false"
              ></v-simple-checkbox>
            </td>
            <td v-for="(header, idx) in questDetailHeaders" :key="idx">
              <span v-if="header.questItemType == 30">
                <img
                  :src="
                    props.item[header.value].startsWith('data')
                      ? props.item[header.value]
                      : $store.state.server + props.item[header.value]
                  "
                  style="width:300px"
                />
              </span>
              <span v-else>{{ props.item[header.value] }}</span>

              <!-- {{header.questItemType}} -->
            </td>
          </tr>
        </template>
        <template v-slot:top>
          <div class="pa-5">
            <div class="row viewList">
              <div class="col-sm-12 col-md-4 col-lg-3">
                <v-select
                  v-model="questSysId"
                  :items="surveys"
                  item-text="questTitle"
                  item-value="questSysId"
                  menu-props="auto"
                  :label="!questSysId ? '尚未選擇問卷' : '已選擇問卷'"
                  outlined
                ></v-select>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-1">
                <v-btn
                  large
                  color="primary"
                  dark
                  class="mb-2"
                  aria-setsize="16px"
                  block
                  @click="query()"
                  >查詢</v-btn
                >
              </div>
              <div class="col-sm-12 col-md-4 col-lg-1">
                <v-btn
                  large
                  color="primary"
                  dark
                  class="mb-2"
                  aria-setsize="16px"
                  block
                  @click="Export()"
                  >匯出</v-btn
                >
              </div>
              <div class="col-sm-12 col-md-4 col-lg-1">
                <v-btn
                  large
                  color="primary"
                  dark
                  class="mb-2"
                  aria-setsize="16px"
                  block
                  @click="deleteResult()"
                  >刪除</v-btn
                >
              </div>
            </div>
            <!-- 警示文字 -->
            <v-alert
              v-for="(alert, idx) in alerts"
              :key="idx"
              v-model="alert.show"
              :type="alert.type"
              dense
              dismissible
            >
              <!-- <template slot="close">
          <v-progress-circular :value="alert.value" :size="20" color="primary">
          </v-progress-circular>
        </template> -->
              {{ alert.msg }}
            </v-alert>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { export_json_to_excel } from '../Excel/Export2Excel'
export default {
  created() {
    this.ques_template = Object.values(this.$store.state.QType)
  },
  mounted() {
    let url = this.$store.state.api + '/Q02010/GetM'
    window.console.log(url)
    this.axios(url).then(res => {
      this.surveys = res.data.questMList
      if (this.questSysId === null) {
        if (this.surveys[0] !== null) {
          this.questSysId = this.surveys[0].questSysId
        }
      }
    })
  },
  data() {
    return {
      questSysId: null,
      questDetailHeaders: [],
      questDetailResults: [],
      singleSelect: false,
      selected: [],
      surveys: [],
      alerts: [], // alert 元件專用容器
      tHeader: [],
      filterVal: [],
      col: [],
      selectItem: [] // bool array，表示哪個 Item 被選中
    }
  },
  methods: {
    returnOri(el) {
      if (el) {
        el.scrollLeft = 0
        el.scrollTop = 0
      }
    },
    enterSelect(values) {
      window.console.log(values)
      if (values.length == 0) {
        for (let i = 0; i < this.selectItem.length; i++) {
          this.selectItem[i] = false
        }
      } else {
        this.selected.splice(0)
        for (let i = 0; i < this.selectItem.length; i++) {
          this.selectItem[i] = true
        }
      }
    },
    query() {
      if (!this.questSysId) {
        this.addAlert('warning', '查詢時沒有提供問卷主檔Id')
        return
      }
      let url = this.$store.state.api + '/Q03020/QueryResult'
      let data = Object.assign({ questSysId: this.questSysId })

      let tHeader = []
      let filterVal = []
      let selectItem = []
      this.tHeader = []
      this.filterVal = []
      this.selected = []
      this.selectItem = []
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        if (res.data.resultCode == '10') {
          //先把array資料舊的的清掉
          this.questDetailHeaders.splice(0)
          this.questDetailResults.splice(0)
          let rows = res.data.rows //headers data
          if (rows.length === 0) {
            return
          }

          let colCnName = [] //儲存答案須改成中文名稱的選項
          for (let i = 0; i < res.data.rows.length; i++) {
            let row = rows[i]
            if (row.item != '') {
              row.item = row.item.split('$')
              colCnName.push(row)
              this.col.push(row)
            }
            this.questDetailHeaders.push(row)
            tHeader.push(row.text)
            filterVal.push(row.value)
          }
          let creatUser = {
            text: '填寫人員',
            value: 'userId'
          }
          let creatTime = {
            text: '填寫時間',
            value: 'creatTime'
          }
          this.questDetailHeaders.push(creatUser)
          this.questDetailHeaders.push(creatTime)
          tHeader.push('填寫時間')
          filterVal.push('creatTime')
          let results = res.data.results //col data
          if (results === null) {
            return
          }

          //將回答選項替換成對應中文
          for (let i = 0; i < res.data.results.length; i++) {
            selectItem.push(false)
            //每一筆回覆
            let result = results[i]
            Object.keys(result).map(function(objectKey, index) {
              let value = result[index]
              for (let j = 0; j < colCnName.length; j++) {
                //去需要更換回答選項名稱的array找需要換的col

                if (colCnName[j].value == objectKey) {
                  //找到同個col
                  let mutiAnsArray = [] //對應選項名稱array
                  if (result[objectKey].indexOf('$') != -1) {
                    window.console.log(result[objectKey])
                    mutiAnsArray = result[objectKey].split('$')
                    //mutiAnsArray.unshift(-1)
                  }
                  let mutiAnsStr = ''
                  for (let k = 0; k < colCnName[j].item.length; k++) {
                    //item中的全部選項

                    if (result[objectKey].indexOf('$') != -1) {
                      //如果是多選題 回復為多個答案
                      for (let x = 0; x < mutiAnsArray.length; x++) {
                        //去比對多選題的對應答案
                        if (mutiAnsArray[x] == k) {
                          //match到 對應選項
                          mutiAnsStr += colCnName[j].item[k]
                          if (k != colCnName[j].item.length - 1) {
                            mutiAnsStr += '、'
                          }
                        }
                      }
                      if (k == colCnName[j].item.length - 1) {
                        result[objectKey] = mutiAnsStr
                      }
                    } else {
                      //其他題目 或多選題為單一回覆
                      if (k === parseInt(result[objectKey])) {
                        //找到對應選項
                        result[objectKey] = colCnName[j].item[k]
                        break
                      }
                    }
                  }
                }
              }
            })
            this.questDetailResults.push(result)
          }

          if (res.data.rows.length > 0) {
            window.console.log(this.questDetailHeaders)
            window.console.log(this.questDetailResults)
            window.console.log(colCnName)
          }
        } else {
          alert(res.data.error)
        }
      })
      this.tHeader = tHeader
      this.filterVal = filterVal
      this.selectItem = selectItem
    },
    deleteResult() {
      if (!this.questSysId) {
        this.addAlert('warning', '請先選擇要刪除的問卷主檔Id')
        return
      }
      window.console.log(parseInt(this.questSysId))
      confirm('是否刪除此份問卷所有回覆') && this.delete(this.questSysId)
    },
    delete(questSysId) {
      let url = this.$store.state.api + '/Q03020/DeleteResult'
      let data = Object.assign({ questSysId: questSysId })
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        if (res.data.resultCode == '10') {
          this.questDetailResults.splice(0)
          alert('刪除成功')
        } else {
          alert(res.data.error)
        }
      })
    },

    Export() {
      try {
        if (this.questSysId == null) throw '匯出時沒有提供問卷主檔Id'

        let anyChecked = false // 是否有任一資料被勾選
        let tmpArr = [] // 暫時的資料容器
        this.selectItem.forEach((isSelected, idx) => {
          if (isSelected) {
            tmpArr.push(this.questDetailResults[idx])
            anyChecked = true
          }
        })
        if (!anyChecked) throw '匯出時沒有勾選匯出資料1'

        this.selected = tmpArr // 重新指定資料給 this.seleced 資料
        window.console.log(this.selected)
      } catch (errStr) {
        this.addAlert('warning', errStr)
        return
      }

      const tHeader = this.tHeader
      // Excel的表格第一行的標題名稱
      const filterVal = this.filterVal
      window.console.log(filterVal)
      // 對應底下資料的屬性名稱

      const list = this.selected //把data里的tableData存到list
      window.console.log(this.selected)
      const data = this.formatJson(filterVal, list)
      let fileName = '未知問卷題目'
      for (let i = 0; i < this.surveys.length; i++) {
        if (this.questSysId == this.surveys[i].questSysId) {
          fileName = this.surveys[i].questTitle
          break
        }
      }
      export_json_to_excel(tHeader, data, fileName)
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    addAlert(type, msg, timeout) {
      // 建立一個 alert 物件並推到 alerts
      let alert = { msg: msg, type: type, show: true, value: 0 }
      this.alerts.push(alert)

      // 檢查 timeout 參數，如果沒有就設為 1.2 秒
      if (timeout === undefined || timeout === null) {
        timeout = 1500
      }
      setTimeout(function() {
        alert.show = false
      }, timeout)
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .Outer {
    width: auto;
  }
  .Inner {
    width: auto;
  }
}
@media (min-width: 1200px) {
  .Outer {
    width: 100%;
    overflow-x: scroll;
  }
  .Inner {
    width: 2600px;
  }
}
</style>
